
<div [ngClass]="{'primary-content' : true, 'pad': smallPad, 'full-pad' : true}">
  <app-primary-menu [fixHeight]="47"></app-primary-menu>
  <app-searchbar (keywordChanged)='onSearchKeywordChange($event)' [keyword]='searchKeyword' [setPlaceholder]="summaryName" [isCatalogue]="true"></app-searchbar>
  <div class="container-fluid pr-create-catalogue custom-scrollbar">
    <div class="row">
      <div class="col left-main-container">
        <div id="product-container" class="container" *ngIf="!isProductDetail;else productDetail">
          <p style="margin: 15px 0;font-size:14px;"><span style="color:#007bc4;">Catalogue </span><span>( {{ noOfItems }}</span> items found )
            <span class="cart-ic" (click)="showCart(template)" title="Show Cart"><img src="../../assets/images/cart-blue.png"></span>
          </p>
          <app-summary [componentId]="catalogueComponentId" (updateParent)="updateCards($event)" [showPagination]="false" (updateTotalRows)="updateTotalRows($event)" [keyword]="searchKeyword"
          (selectedCardId)='onSelectedItem($event)' (setSummaryName)="setSummaryName($event)"></app-summary>
        </div>
        <ng-template #productDetail>
          <app-product-detail [setComponentId]="selectedProductDetailId"></app-product-detail>
        </ng-template>
      </div>
      <div class="col right-main-container">
        <div class="sticky-offset cart">
          <div class="cart-container">
            <h5 class="cart-title">Requisition Cart</h5>
            <app-detail #cart [setComponentId]='cartComponentId'></app-detail>
          </div>
        </div>
        <div class="cart-desc"><p>Can't find what you need?</p><p>Click <a href="javascript:void(0)">here</a> to create a free text request</p></div>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<ng-template #template>
    <div class="modal-header">
        <h5 class="modal-title">Requisition Cart</h5>
        <button type="button" class="close close-modal" data-dismiss="modal" aria-label="Close" (click)="onDecline()">
            <span aria-hidden="true" style="font-size: 30px;">&times;</span>
        </button>
    </div>
    <div class="modal-body">
      <div class="col">
        <div class="sticky-offset cart-m">
          <div class="cart-container">
            <app-detail #cart [setComponentId]='cartComponentId'></app-detail>
          </div>
        </div>
        <div style="margin-top: 15px;font-size:13px;"><p>Can't find what you need?</p><p>Click <a href="javascript:void(0)">here</a> to create a free text request</p></div>
      </div>
    </div>
</ng-template>

